module.exports = __webpack_public_path__ + "media/images/germany_flag-be5eb19fc155de5bbbff967b8920166e.jpg";